import Image from 'next/image';
import React from 'react';

import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import {
  useModalContext,
  openCitySelectorModal,
} from '../../../../contexts/modal-context/ModalContext';
import {
  ImageEntity,
  TextSubtext,
  CityServices,
} from '../../../cities/domain/entities/CitiesEntity';
import { GA_CITY_SELECTOR_ACTION } from '../../../core/constants/GAEventsConstants';
import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

import styles from '../../../../containers/home/view/styles/CitySelector.module.scss';

interface CitySelectorCmpProps {
  city_selector_data: CityServices[];
  location_icon: ImageEntity;
  drop_down_icon: ImageEntity;
  close_icon: ImageEntity;
  city_title_desc: TextSubtext;
  city_label_prefix: string;
}

function CitySelectorCmp({
  city_selector_data,
  location_icon,
  drop_down_icon,
  close_icon,
  city_title_desc,
  city_label_prefix,
}: CitySelectorCmpProps): React.ReactElement {
  const modalContext = useModalContext();
  const citySelectedContext = useCitySelectedContext();

  const handleClick = (): void => {
    if (city_selector_data.length > 1) {
      publishGa4Events(
        citySelectedContext.category,
        GA_CITY_SELECTOR_ACTION,
        citySelectedContext.city_selected,
      );
      modalContext.toggleModal(
        openCitySelectorModal(city_selector_data, close_icon, city_title_desc),
      );
    }
  };

  return (
    <div className={styles['city-selector-wrapper']}>
      <div className={styles['city-selector-button']} onClick={handleClick}>
        <Image
          src={location_icon.path}
          alt={location_icon.alt_text}
          width={20}
          height={20}
          quality={100}
        />
        <div className={styles['city-selector-text-wrapper']}>
          <p className={styles['city-selector-text']}>{city_label_prefix}</p>
          <p className={styles['city-selected-text']}>
            {citySelectedContext.selected_city_label ?? ''}
          </p>
        </div>
        {city_selector_data.length > 1 ? (
          <Image
            src={drop_down_icon.path}
            width={20}
            height={20}
            alt={drop_down_icon.alt_text}
            quality={100}
          />
        ) : null}
      </div>
    </div>
  );
}

export default CitySelectorCmp;
